import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../style/colors';
import { useDictionary } from '../../../contexts/dictionary';
import { Link } from 'react-router-dom';
import { useDeviceType } from '../../../contexts/DeviceContext';



interface Step {
  label: string;
  link:string;
}

interface ProgressBarProps {
  steps: Step[];
  currentStep: number;
}


export const TitleProgressBar: React.FC<ProgressBarProps> = ({ steps, currentStep }) => {
  const {translate} = useDictionary();
  const {isMobile} =   useDeviceType()
  return (
    <Wrapper $isMobile={isMobile}>
      <ProgressBarContainer $isMobile={isMobile}>
        {steps.map((step, index) => (
          <StepWrapper  key={index} $isMobile={isMobile} $stepCount={steps.length} $isLast={ isMobile || index === steps.length - 1} className='step-wrapper'>
            <Link to={step.link}>
            <Step>
              <Circle active={index <= currentStep}>{index + 1}</Circle>
              <StepLabel active={index <= currentStep} $isMobile={isMobile}>{translate(step.label)}</StepLabel>
            </Step>
            </Link>
            {!isMobile && index < steps.length - 1 && (
              <Connector active={index < currentStep} className='connector'/>
            )}
          </StepWrapper>
        ))}
      </ProgressBarContainer>
    </Wrapper>
  );
};

// Styled Components20px 40px

const Wrapper = styled.div<{$isMobile?: boolean}>`
  width: 100%;
  padding: ${props=> props.$isMobile ? '0 20px' : '20px 40px'};
  
`;

const ProgressBarContainer = styled.div<{$isMobile: boolean}>`
  display: flex;
  align-items: ${props => props.$isMobile ? 'flex-start' : 'center'};
  justify-content: space-between;
  gap: 5px;
`;

const StepWrapper = styled.div<{$isLast: boolean,$stepCount: number , $isMobile: boolean}>`

  
  ${({ $isMobile}) => !$isMobile && ` display: flex;`}
  align-items: center;  
  ${({ $isMobile,$stepCount }) => $isMobile && `width: calc(100% /${$stepCount });`}
  ${({ $isLast }) => !$isLast && `flex: 1;`}
  position: relative;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  
`;

const Circle = styled.div<{ active: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? Colors.primary : Colors.placeholder)};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StepLabel = styled.div<{ active: boolean ,$isMobile?: boolean}>`
  margin-top: 6px;
  font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
  font-weight: 500;
  color: ${({ active }) => (active ? Colors.primary : Colors.placeholder)};
  text-align: center;
`;

const Connector = styled.div<{ active: boolean }>`
  height: 2px;
  background: blue;
  margin-bottom: 22px;
  flex: 1;
  background-color: ${({ active }) => (active ? Colors.primary : Colors.placeholder)};
  margin-left: 8px;
  margin-right: 8px;
  z-index: 1;
`;
